
const RoleActions = {
  DASHBOARD: 1,
  SERVICE_ACCOUNTS: 2,
  EMAIL_MANAGEMENT: 3,
  CONTACT_LIST: 4,
  VISIT_HISTORY: 5,
  CHALLENGE_LIST: 6,
  CHALLENGE_LOG_LIST: 7,
  PROBLEM_EDITOR: 8,
  ALL_PROBLEMS: 9,
  CHALLENGE_EDITOR: 10,
  ALL_CHALLENGES: 11,
  DV2_CHALLENGE_SCORE: 12,
  JOB_EDITOR: 13,
  JOB_LIST: 14,
  JOB_APPLY_LIST: 15,
  DESIGN_CHALLENGE_LIST: 16,
  MCQ_SCORE_SUMMARY: 17,
  BUG_REPORT_LIST: 18,
  QA_ACCOUNTS_LIST: 19,
  CHALLENGE_STATISTICS: 20,
  RESET_CANDIDATE_TEST: 21,
  SETUP_MCQ_ROLE_PREFERED: 22,
  SETUP_LABEL_AREA_RELATIONSHIP: 23,
  MCQ_SURVEY: 24,
  UPDATE_MCQ_SCORE: 25,
  CHALLENGE_AB_TEST_CONFIGURATION: 26,
  MCQ_COPY_EDITOR: 27,
  LOGIN_AS_USER: 28,
  SETUP_STACK_DEMAND: 29,
  INTERVIEW_ELIGIBILITY: 30,
  UPDATE_CANDIDATES_STATUS: 31,
  LIVE_CODE_INTERVIEW: 32,
  ACCOUNT_MANAGEMENT: 33,
  SETUP_AVAILABILITY: 34,
  ADMIN_CALENDAR_SETUP: 35,
  ADMIN_LIST_BOOKED_EVENT: 36,
  ADMIN_LIST_CALENDARS: 37,
  INTERVIEWER_PERFORMANCE_REPORT: 40,
  INTERVIEWER_AVAILABILITY_REPORT: 41,
  USER_PROFILE_VIEW: 42,
  SETUP_SKILL_RELATIONSHIP: 43,
  SETUP_SKILL_MCQ_RELATIONSHIP: 44,
  SETUP_DEMAND_STACK_SKILL: 45,
  UPDATE_DEVELOPER_SENIORITY: 46,
  JOB_SEARCH: 47,
  CREATE_TEST_ACCOUNT: 48,
  CREATE_ACCOUNT_BY_RESUME: 49,
  S_PARAM_MANAGEMENT: 50,
  CONTENT_MANAGEMENT_SYSTEM: 51,
  CHANGE_CANDIDATE_EMAIL: 52,
  VETSMITH: 53,
  DELETE_USER: 54,
  CLOUD_INSTITUTE: 55,
};

function checkIfRoleCan (roleId) {
  const allowed_action = localStorage.getItem('allowed_action') || '';
  return allowed_action.split(',').includes(`${roleId}`);
}

export { checkIfRoleCan };
export default RoleActions;
